import employService from "@/services/employ";
import Utils from "@/mixins/Utils";
import { mapGetters, mapActions } from "vuex";
import jobofferService from "../../services/jobOffer";
import {SALARY_TIME_UNIT, TRANSPORT_TYPES} from "../../constants/jobOffer";
import moment from "moment";
import agencyService from "@/services/agency";

export default {
  data() {
    return {
      teamMembers: null,
      agencyNews: null,
      jobOffer: null,
      agency: null,
      applicationInfo: {
        hasAppliedTo: false,
        applicationDate: "",
      },
      googleApiKey: process.env.VUE_APP_GOOGLE_API_KEY,
      windowWidth: window.innerWidth,
      contractMaxHeight: 0,
      contractRefArr: ['typeContract', 'dateEnd', 'planning', 'salary', 'workType', 'rqth', 'dateStart']
    };
  },
  mixins: [Utils],
  computed: {
    ...mapGetters({
      pageLoading: "isLoading",
      jobOfferError: "errorMessage",
    }),
    ...mapGetters('profile', ['profileInfo', 'fullProfileInfo']),
    idJobOffer() {
      return this.$route.query.id;
    },
    locality() {
      return this.$route.query.locality;
    },
    jobOfferSubTitle() {
      return this.jobOffer? this.$t('job-offer-detail-sub-title').replace('[city]', `${this.jobOffer.city} (${this.jobOffer.zipCode})`) : '';
    },
    jobOfferLocation() {
      return {
        lat: this.jobOffer.latitude,
        lng: this.jobOffer.longitude
      }
    },

    staticMapURL() {
      if (this.jobOffer.address)
        return `https://maps.google.com/maps/api/staticmap?
          center=${this.jobOffer.address}
          &size=365x256&scale=1&sensor=false&zoom=16
          &markers=${this.jobOffer.address}
          &key=${this.googleApiKey}`;
    },

    staticMapLinkURL() {
      if (this.jobOffer.address)
        return `http://maps.google.com/maps?q=${this.jobOffer.address}`;
    },

    isShowContract() {
      return this.jobOffer.dateEnd && this.jobOffer.planning && this.jobOffer.salaryRangeMin && this.jobOffer.salaryRangeMax && this.jobOffer.salaryFactor 
    },
    ...mapGetters('auth', {
      generalSetting : 'generalSetting'
    })
  },

  created() {
    this.loadJobOffer();
  },
  watch: {
    pageLoading(val) {
      if (!val) {
        this.checkItemListHeight();
      }
    }
  },
  mounted() {
    window.addEventListener('resize', this.setWindowWidth);
  },
  unmounted() {
    window.removeEventListener('resize', this.setWindowWidth);
  },
  methods: {
    ...mapActions('profile', ['getProfileInfo']),
    checkItemListHeight() {
      const contractElArr = this.contractRefArr.filter(item => this.$refs[item]);
      const middleIndex = contractElArr.length > 4 ? Math.round(contractElArr.length / 2) + 1 : contractElArr.length;
      contractElArr.forEach((item, i) => {
        if (i >= middleIndex) return;
        const currElHeight = this.$refs[item].offsetHeight;
        this.contractMaxHeight += (currElHeight);

        if (contractElArr[i+1]) {
          const nextElHieght = this.$refs[contractElArr[i+1]].offsetHeight;
          console.log('nextElHieght', nextElHieght, 'currElHeight', currElHeight);
          if (nextElHieght > currElHeight) {
            this.$refs[item].classList.add('long-line')
          }
        }
      })
    },
    setWindowWidth() {
      this.windowWidth = window.innerWidth
    },
    scroll(id) {  
      document.getElementById(id).scrollIntoView({
        behavior: "smooth"
      });
    },
    duration(date) {
      const thisMonth = moment().month();
      const endMonth = moment(date).month();
      const result = endMonth - thisMonth;

      return result <= 1 ? 1 : result;
    },
    renderSalaryFactor(timeUnit) {
      return parseInt(timeUnit) === SALARY_TIME_UNIT.HOUR ? this.$t('hour') : this.$t('month-label')
    },
    loadJobOffer() {
      const vue = this;
      const jobOfferId = this.$route.query.id;
      jobofferService
        .getJobOffer(jobOfferId)
        .then((res) => {
          if (res.success && res.data.idJobOffer) {
            this.jobOffer = res.data;
            const idAgency = res.data.idAgence;
            this.loadTeamMembers(idAgency);
            this.loadAgencyNews(idAgency);
            setTimeout(() => this.checkItemListHeight(), 2000);
          } else {
            this.callToaster(this.$t('problem-arise'));
            setTimeout(() => {
              this.$router.go(-1);
            }, 1000)
          }
        })
        .catch((err) => {
          vue.callToaster(vue.$t('problem-arise'));
        });
    },
    annulerOffre(idCandidature) {
      jobofferService
        .deleteCandidature(idCandidature)
        .then((res) => {
          if (res.success) {
            this.callToaster(this.$t('cancel-candidature-success'));
            this.jobOffer.hasAppliedTo = false;
            return;
          }
          this.callToaster(res.message);
        })
        .catch((err) => {
          this.callToaster(this.$t('problem-arise'));
        });
    },
    handleApplyJobOffer(data) {
      const typeSTransports = [];
      Object.keys(TRANSPORT_TYPES).forEach(key => {
        if (data[key]) {
          typeSTransports.push({
            pkIxTypesTransport: TRANSPORT_TYPES[key].value
          })
        }
      });
      const body = {
        "longitude": data.lng,
        "latitude": data.lat,
        "pkJobOffer": this.idJobOffer || null,
        "experiences": data.experiences,
        "formations": data.formations,
        "pkCivility": data.pkIxGender,
        "firstName": data.firstName,
        "lastName": data.name,
        "email": data.email,
        "phone": data.tel,
        "city": data.city,
        "zipcode": data.zipcode,
        "typesTransports": typeSTransports
      }
      body['experiences'].forEach(exp => {
        if (exp.startDate) {
          exp.startDate = new Date(exp.startDate).getTime();
        }
        if (exp.endDate) {
          exp.endDate = new Date(exp.endDate).getTime();
        }
      })
      jobofferService.applyJobOffer(body).then(res => {
        if (res.success) {
          this.callToaster(this.$t('apply-job-offer-success'));
          this.jobOffer.applicationDate = new Date();
          this.jobOffer.hasAppliedTo = true;
          this.jobOffer.id = res.data.IDCandidature;
        } else {
          this.callToaster(res.message)
        }
      }).catch((err) => {
        this.callToaster(err || this.$t('problem-arise'))
      });
    },
    applyForJobOffer() {
      const isAuthenticated = Boolean(localStorage.getItem("isAuthenticated"));
      if (!isAuthenticated) {
        const route = "/public/" + this.$route.params.company + "/sign-up";
        if(this.generalSetting.redirectPageToApply) {
          window.location.replace(this.generalSetting.redirectPageToApply)
        } else {
        this.$router.push({
          path: route,
          query: {
            id: this.jobOffer.idJobOffer ? this.jobOffer.idJobOffer : null,
            locality: this.locality
          },
        });
        }
      } else {
        if (this.profileInfo) {
          this.handleApplyJobOffer(this.profileInfo);
        } else {
          this.getProfileInfo().then(res => {
            this.handleApplyJobOffer(res.data);
          }).catch(err => {
            this.callToaster(err || this.$t('problem-arise'));
          })
        }
      }
    },
    async loadTeamMembers(pkAgency) {
      await agencyService
        .getTeamMembers(pkAgency)
        .then((res) => {
          this.teamMembers = res.data.cdcs;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async loadAgencyNews(pkAgency) {
      await agencyService
        .getAgencyNews(pkAgency)
        .then((res) => {
          let data = [];
          res.forEach(async (item) => {
            const featuredMedia = await agencyService.getFeaturedMedia(item.featured_media).then(res => res);
            const { title, date, link } = item;
            const { source_url, alt_text } = featuredMedia;
            data.push({ title, date: this.formatDate(date), link, source_url, alt_text })
          });
          this.agencyNews = data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    formatDate(date) {
      return this.$options.filters.formatUnixFullDate(new Date(date).getTime());
    },
  },
};
